import { render, staticRenderFns } from "./CustomerEditor.vue?vue&type=template&id=a976b338"
import script from "./CustomerEditor.vue?vue&type=script&lang=js"
export * from "./CustomerEditor.vue?vue&type=script&lang=js"
import style0 from "./CustomerEditor.vue?vue&type=style&index=0&id=a976b338&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports